import React from 'react';
import { array, object, bool, string } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import SellerCard from '../../../../shared/components/SellerCard';
import Variations from '../Variations';
import { useChooseVariationContext } from '../Context';
import './style.scss';

const { reportSellerAvatarClicked } = makersExperience.chooseVariation;

const VariationsRow = ({ variations, isProjectOwner, copiesKey, withoutTitle = false }) =>
    !!variations.length && (
        <div className="thumbnails-section">
            {!withoutTitle && (
                <h3>
                    <I18n k={`logo_maker_perseus.choose_variation.thumbnails.${copiesKey}.title`} />
                </h3>
            )}
            <Variations variations={variations} isProjectOwner={isProjectOwner} />
        </div>
    );

VariationsRow.propTypes = {
    variations: array,
    isProjectOwner: bool,
    copiesKey: string,
    withoutTitle: bool,
};

const VariationsColumn = ({ seller, isMobileOrTabletSize, isProjectOwner = false }) => {
    const { draftVariations, orderedVariations, suggestedVariations } = useChooseVariationContext();

    return (
        <div className="col-12-xs col-4-md col-3-lg variations-column">
            <header>
                <h2>
                    <I18n k="logo_maker_perseus.choose_variation.header.page_title" />
                </h2>
            </header>

            {!isMobileOrTabletSize && (
                <div className="thumbnails">
                    <VariationsRow
                        variations={draftVariations}
                        isProjectOwner={isProjectOwner}
                        copiesKey="your_designs"
                    />
                    <VariationsRow
                        variations={orderedVariations}
                        isProjectOwner={isProjectOwner}
                        copiesKey="your_orders"
                    />
                    <VariationsRow
                        variations={suggestedVariations}
                        isProjectOwner={isProjectOwner}
                        copiesKey="designer_recommended"
                        withoutTitle={!draftVariations.length && !orderedVariations.length}
                    />
                </div>
            )}

            <SellerCard seller={seller} onAvatarClick={reportSellerAvatarClicked} />
        </div>
    );
};

VariationsColumn.propTypes = {
    seller: object,
    isMobileOrTabletSize: bool,
    isProjectOwner: bool,
};

export default VariationsColumn;
